import React from 'react';
import { Box, Stack, Breadcrumbs, Link, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Container from 'components/Container';
import CustomBreadcrumbs from '../CustomBreadcrumbs';

import { CtaSection, CoverSlider } from './components';

interface IProps {
  title: string;
  subTitle: string;
  buttonText: string;
  href?: string;
  imageSrc?: string;
  imageAlt?: string;
  breadcrumbs?: {
    href?: string;
    title: string;
  }[];
}

const FullScreenHeroWithImageSlider: React.FC<IProps> = ({
  title,
  subTitle,
  buttonText,
  href,
  imageSrc,
  imageAlt,
  breadcrumbs,
}): JSX.Element => {
  return (
    <Box
      sx={{
        width: 1,
        height: 1,
        overflow: 'hidden',
      }}
    >
      <Container paddingX={0} paddingY={0} maxWidth={{ sm: 1, md: 1236 }}>
        <Box
          display={'flex'}
          flexDirection={{ xs: 'column', md: 'row' }}
          position={'relative'}
          minHeight={{ xs: 'auto', md: 618 }}
          sx={{
            justifyContent: 'space-between',
            paddingTop: '100px',
          }}
        >
          <Box
            width={1}
            order={{ xs: 2, md: 1 }}
            display={'flex'}
            sx={{ width: { md: '50%' } }}
            // alignItems={'center'}
          >
            <Container
              display="flex"
              flexDirection="column"
              alignItems="stretch"
              maxHeight={{ xs: 'unset', md: 1 }}
            >
              <CtaSection
                title={title}
                subTitle={subTitle}
                buttonText={buttonText}
                href={href}
              />
              {breadcrumbs && (
                <CustomBreadcrumbs
                  breadcrumbs={breadcrumbs}
                  breadcrumbSx={{ mt: 7 }}
                />
              )}
            </Container>
          </Box>
          <Box
            order={{ xs: 1, md: 2 }}
            display={'flex'}
            alignItems={'flex-start'}
            sx={{ margin: { xs: '0 auto', md: 'unset' } }}
          >
            <CoverSlider imageSrc={imageSrc} imageAlt={imageAlt} height={434} />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default FullScreenHeroWithImageSlider;
